<div class="header-wrapper d-lg-none sticky-top" [class.search-active]="showSearchBar()"
  (click)="showSearchBar.set(false)" (keyup)="noop($event)" tabindex="-1">
  <header class="sticky-top" (click)="$event.stopPropagation()" (keyup)="noop($event)"
    [class.search-active]="showSearchBar()" tabindex="-1" (keyup)="noop($event)">
    @if(showSearchBar()){
    <div class="container-md d-flex flex-wrap align-items-center justify-content-between pt-3">
      <form class="input-group w-100 px-2" method="get" (submit)="search()">
        <input #searchInput id="searchInput" type="text" class="form-control" placeholder="Search..." [ngModel]="searchText()"
          (ngModelChange)="searchText.set($event)" (focus)="showSearchBar.set(true)" name="search" />
        <button id="searchButton" type="submit" class="btn btn-gold" aria-label="Search" title="Search">
          <fa-icon [icon]="faSearch"></fa-icon>
        </button>
      </form>
    </div>
    } @else {
    <div class="container-md d-flex flex-wrap align-items-center justify-content-between pt-3">
      @if(!isBrandedView()){ <nav class="navbar navbar-expand-lg navbar-light p-0" aria-label="Menu toggle">
        <button class="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#headerNavbarMobile"
          aria-controls="headerNavbarMobile" aria-expanded="false" aria-label="Toggle navigation"
          (click)="isMenuCollapsed.set(!isMenuCollapsed())">
          <fa-icon [icon]="faBars"></fa-icon>
        </button>
      </nav>}
      <a [routerLink]="homePath()" (click)="onLogoClick()" class="col-4 col-md-2 text-dark text-decoration-none logo-home"
        [class.hidden]="showSearchBar()">
        <img src="/assets/img/memorabid-logo-white.svg" alt="Logo" />
      </a>
      <div class="col-md-3 text-end ms-auto icon--mobile" [class.hidden]="showSearchBar()">
        @if(!isBrandedView()) {
        <button type="button" class="iconButton" (click)="toggleSearchBar()" title="Toggle search"
          aria-label="Toggle search">
          <fa-icon [icon]="faSearch" size="lg"></fa-icon>
        </button>
        }
        @if(messageService.userDataCount.unpaidItems){
        <button type="button" class="iconButton button-with-badge" (click)="onIconPressed('account/cart')"
          aria-label="Cart" title="Cart">
          <i class="pi pi-shopping-cart"></i>
          <span class="badge" [class.badge-two-digits]="
              messageService.userDataCount.unpaidItems > 9
            ">
            {{ messageService.userDataCount.unpaidItems }}
          </span>
        </button>
        } @if(authService.isAuthenticated()){
        <a type="button" class="iconButton" [routerLink]="[
            '/',
            languageService.userSelectedLanguage.code,
            'search-result-all'
          ]" [queryParams]="{ onlyFavorites: true, auctionStatus: -1 }" aria-label="Favorites" title="Favorites">
          <fa-icon [icon]="faHeart" size="lg"></fa-icon>
        </a>
        }
        <button type="button" class="iconButton button-with-badge"
          (click)="onIconPressed(authService.userLogged?.idProfile === 1 ? 'admin/message/list' : 'account/messages')"
          aria-label="Messages" title="Messages">
          <fa-icon [icon]="faEnvelope" size="lg"></fa-icon>
          @if(messageService.unreadMessagesCount > 0){
          <span class="badge" [class.badge-two-digits]="messageService.unreadMessagesCount > 9">
            {{
            messageService.unreadMessagesCount > 99
            ? "99+"
            : messageService.unreadMessagesCount
            }}
          </span>
          }
        </button>
        <div ngbDropdown class="iconButton text-center" #accountMobileDropdown="ngbDropdown">
          <button id="accountDropdownMobile" type="button" class="iconButton" (click)="onAccountPressed('account')"
            ngbDropdownToggle aria-label="Account" title="Account">
            <fa-icon [icon]="faUser" size="lg"></fa-icon>
          </button>
          @if(authService.userLogged.idProfile !== 1){
          <div ngbDropdownMenu aria-labelledby="filterDropdown" class="accountDropdownMobile">
            <p class="mb-0 text-nowrap accountNameDropdown">
              <i>{{ "IDS_HI" | translate
                }}{{ authService.userLogged.username }}</i>
            </p>
            <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
              {{ "IDS_ACCOUNT" | translate }}
            </button>
            <button type="button" ngbDropdownItem class="accountDropdownLink"
              (click)="onIconPressed('account/my-auctions/awarded')">
              {{ "IDS_AUCTIONS" | translate }}
            </button>
            <hr />
            <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
              {{ "IDS_LOGOUT" | translate }}
            </button>
          </div>
          } @if(authService.userLogged.idProfile === 1){
          <div ngbDropdownMenu aria-labelledby="filterDropdown" class="accountDropdownMobile">
            <p class="mb-0 text-nowrap accountNameDropdown">
              <i>{{ "IDS_HI" | translate
                }}{{ authService.userLogged.username }}</i>
            </p>
            <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('account')">
              {{ "IDS_ADMIN" | translate }}
            </button>
            <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="onIconPressed('admin-v2')">
              {{ "IDS_ADMIN" | translate }} V2
            </button>
            <hr />
            <button type="button" ngbDropdownItem class="accountDropdownLink" (click)="logout()">
              {{ "IDS_LOGOUT" | translate }}
            </button>
          </div>
          }
        </div>
      </div>
    </div>
    }
    <div
      class="container-md d-flex align-items-center py-2">
        <div class="d-flex gap-2 align-items-stretch w-100 px-2" >
          @if(fullPathHeaderPages().length){
            @for(btn of fullPathHeaderPages(); track btn.route){
              <button type="button" class="navbar-btn " (click)="resetAuctionSource()" [routerLink]="btn.route">{{
              btn.label | translate
              }}</button>
            }
          }
        </div>
    </div>

    <nav class="navbar navbar-expand-lg navbar-light p-0" aria-label="Main navigation">
      <div class="container-md">
        <div [ngbCollapse]="isMenuCollapsed()" class="collapse navbar-collapse align-items-stretch" id="headerNavbarMobile">
          <ul class="navbar-nav ms-auto">
            @for(
            link of links(); track link.route
            ){
            <li class="item-right-navbar" routerLinkActive="active-link">
              <a class="nav-link text-uppercase {{ link.class }}" (click)="resetAuctionSource()" routerLink="{{
                                          '/' +
                                            languageService.userSelectedLanguage.code +
                                            link.route
                                        }}">{{ link.label | translate }}</a>
            </li>
            }
          </ul>
          <div ngbDropdown class="ms-1 align-self-center">
            <button id="languageDropdownMobile" type="button" ngbDropdownToggle title="Select language"
              aria-label="Select language">
              <img class="flagImg" [src]="imgCountry()" alt="flag" />
            </button>
            <div ngbDropdownMenu aria-labelledby="languageDropdownMobile" class="dropdown-menu-lg-end">
              @for(lang of languageService.AppLanguageList; track lang.code){
              <button (click)="changeLanguages(lang)" type="button" ngbDropdownItem
                class="lang-dropdown justify-content-center align-items-center d-flex">
                <p class="pt-3">{{ lang.description }}</p>
                &nbsp;&nbsp;
                <img class="flagImg" src="/assets/img/{{ lang.code }}.png" alt="flag" />
              </button>
              }
            </div>
          </div>
        </div>
      </div>
    </nav>
  </header>
</div>
